import React, {useState} from 'react';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";
import {report_strings} from "../../translations/report_translations";
import {Col} from "react-grid-system";
import {Popover, PopoverHeader, PopoverBody, UncontrolledPopover, Table} from 'reactstrap';
import CPTableRow from "../Tables/CPTableRow";
import Button from "reactstrap/es/Button";

const raiseColor = "#eb9d9d"
const raise10Color = "#ce7474"
const raise20Color = "#bd5757"
const raise30Color = "#ac4242"
const raise40Color = "#8e3636"
const raise50Color = "#722020"
const callColor = "#a6e3ab"
const foldColor = "#c4d7e6"

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);
let reportStrings = new LocalizedStrings(report_strings);

const PlayCard = (props) => {
    const [cardData, setCardData] = useState(props.cardData);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const toggle = () => setPopoverOpen(!popoverOpen);

    localize();

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
    }

    function getColor(element) {
        switch (element.t) {
            case "r":
                return raiseColor
            case "r10":
                return raise10Color
            case "r20":
                return raise20Color
            case "r30":
                return raise30Color
            case "r40":
                return raise40Color
            case "r50":
                return raise50Color
            case "f":
                return foldColor
            case "c":
                return callColor
            default:
                return "white"
        }
    }

    function generateBackground() {
        if (!cardData.a || cardData.a.length == 0) {
            return "white"
        } else {
            if (cardData.a.length == 1) {
                let res = getColor(cardData.a[0])
                return res
                //return `linear-gradient(to right, #c4d7e6 0, #c4d7e6 33%, #a6e3ab 33%, #a6e3ab 66%, #eb9d9d 66%, #eb9d9d 100%)`
            } else if (cardData.a.length > 2) {
                let value = `linear-gradient(to right,`;
                let i = 0;
                let shift = 0;

                for (i = 0; i < cardData.a.length; i++) {
                    value += ` ${getColor(cardData.a[i])} ${shift}${shift == 0 ? "," : "%,"} ${getColor(cardData.a[i])}`
                    shift += cardData.a[i].v.str
                    value += ` ${shift}%` + (i == cardData.a.length - 1 ? "" : ",")
                }

                value += ')'
                return value
                // return  "linear-gradient(to right, #a6e3ab 0, #a6e3ab 40%, #c4d7e6 40%, #c4d7e6 60%, #eb9d9d 60%, #eb9d9d 80%, #a6e3ab 80%, #a6e3ab 100%)"
                // return "linear-gradient(to right, #a6e3ab 0, #a6e3ab 40%, #c4d7e6 40%, #a6e3ab 60%, #ce7474 60%, #a6e3ab 80%, #bd5757 80%, #a6e3ab 100%)"

            } else if (cardData.a.length == 2) {
                let n = `linear-gradient(to right, ${getColor(cardData.a[0])} 0, ${getColor(cardData.a[0])} ${cardData.a[0].v.str}%, ${getColor(cardData.a[1])} ${cardData.a[0].v.str}%, ${getColor(cardData.a[1])} 100%)`
                return n
            } else return "linear-gradient(to right, #a6e3ab 0, #a6e3ab 30%, #c4d7e6 30%, #c4d7e6 60%, #eb9d9d 60%, #eb9d9d 100%)"
        }
    }

    return (
        <Col lg={1} sm={1} xs={1} xl={1} md={1} xxl={1}
             id={"popover_id" + cardData.l}
             style={{
                 maxLines: 1,
                 fontSize: "0.8rem",
                 width: "100%",
                 borderRadius: "6px",
                 margin: "1px",
                 background: generateBackground(),
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center"
             }}>
            <label
                className={cardData.l.length == 2 ? "text-center text-default font-weight-bold m-0" : "text-center font-weight-light text-default m-0"}
            >{cardData.l}</label>
            <UncontrolledPopover trigger="legacy" placement="bottom" target={"popover_id" + cardData.l}>
                <PopoverHeader className="popover-default text-white">{cardData.l}</PopoverHeader>
                <PopoverBody style={{padding: 0}}>
                    <Table
                        className="align-items-center table-light table-flush" style={{margin: 0, padding: 0}}
                        responsive
                    >
                        <thead className="thead-light" style={{height: 10}}>
                        <tr style={{height: 10}}>
                            <th className="pb-1 pt-1" scope="col"/>
                            <th className="pb-1 pt-1" scope="col"><b>STR</b></th>
                            <th className="pb-1 pt-1" scope="col"><b>EV</b></th>
                        </tr>
                        </thead>

                        <tbody>
                        {cardData.a.map((action, index) => {
                            return (
                                <tr key={"ai-" + index} style={{height: 10}}>
                                    <td style={{width: 3, paddingTop: 0, paddingBottom: 4,}}>
                                       <b>{action.t.toUpperCase()}</b>
                                    </td>

                                    <td style={{width: 3, paddingTop: 0, paddingBottom: 4,}}>
                                        {action.v.str}%
                                    </td>

                                    <td style={{width: 3, paddingTop: 0, paddingBottom: 4,}} className={action.v.ev > 0 ? "text-success" : "text-danger"}>
                                        {action.v.ev}
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </Table>
                </PopoverBody>
            </UncontrolledPopover>

        </Col>
    );
};

export default PlayCard;